import React from 'react';
import ImgCrop from 'antd-img-crop';
import { Upload, message, Form, InputNumber, Select } from 'antd';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';

import { getTranslationCache } from '../../../selectors/language';
import { getUserProfile } from '../../../selectors/layout';
//import { constant } from './constants';
import localStorage from '../../../utils/localStorage';
import { API_SITE } from '../../../commons/api';

const { Option } = Select;

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

class LogoUploadFile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      siteId: '',
      width: 1000,
      height: 250,
      translationCache: props.translationCache || [],
      userProfile: props && props.userProfile ? props.userProfile : {},
      siteList: [],
      disableUpload: true,
      disableWidth: true,
      disableHeight: true,
      UploadedImage: ''
    };
  }

  componentDidMount() {
    this._getsiteList(this.props.userProfile);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.translationCache !== this.props.translationCache) {
      this.setState({
        translationCache: this.props.translationCache
      });
    }
    if (this.props.userProfile !== prevProps.userProfile) {
      this._getsiteList(this.props.userProfile);
    }
  }

  beforeUpload = (file) => {
    let { siteId } = this.state;
    if (siteId) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJPG) {
        message.error('You can only upload JPG file!');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error('Image must smaller than 2MB!');
      }
      return isJPG && isLt2M;
    }
  };

  _getsiteList = (userProfile) => {
    let siteList =
      this.props && userProfile && userProfile.belongsTo && userProfile.belongsTo.sites
        ? userProfile.belongsTo.sites
        : null;

    this.setState({ siteList });
  };

  handleChange = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
      // return;
    }
    if (info.file.status === 'done') {
      this.setState({
        UploadedImage: info.file.name
      });
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (imageUrl) =>
        this.setState({
          imageUrl,
          loading: false
        })
      );
    }
  };

  setParameter = (parameter, value) => {
    if (parameter === 'width') {
      this.setState({
        width: value
      });
    } else if (parameter === 'height') {
      this.setState({
        height: value
      });
    }
  };

  translation = (keyword) => {
    let { translationCache } = this.props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  onSiteChange = (siteId) => {
    this.setState({
      siteId,
      disableWidth: false
    });
  };

  render() {
    const {
      width,
      height,
      siteList,
      siteId,
      disableUpload,
      disableWidth,
      disableHeight,
      UploadedImage
    } = this.state;
    const userSite = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
    var Authorization = 'Bearer ' + token;
    const uploadButton = (
      <div>
        {this.state.loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div className="ant-upload-text">{this.translation('Upload')}</div>
      </div>
    );

    return (
      <Form name="basic" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
        <Form.Item
          label={this.translation('Select Site')}
          name="siteId"
          rules={[{ required: true, message: 'Select Site' }]}
        >
          <Select
            placeholder={this.translation('Select Site')}
            style={{ width: '300px' }}
            onChange={this.onSiteChange}
          >
            {siteList &&
              Object.keys(siteList).map((item) => (
                <Option key={siteList[item].site.Id} value={item}>
                  {siteList[item].site.Name}
                </Option>
              ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={this.translation('Image Width')}
          name="width"
          rules={[{ required: true, message: [this.translation('Please input width!')] }]}
        >
          <InputNumber
            style={{ width: '300px' }}
            disabled={disableWidth}
            onChange={(width) => {
              if (siteId !== '') {
                this.setState({ width, disableHeight: false });
              }
            }}
          />
        </Form.Item>

        <Form.Item
          label={this.translation('Image Height')}
          name="height"
          rules={[{ required: true, message: [this.translation('Please input height!')] }]}
        >
          <InputNumber
            style={{ width: '300px' }}
            disabled={disableHeight}
            onChange={(height) => {
              if (height) {
                this.setState({ height, disableUpload: false });
              }
            }}
          />
        </Form.Item>

        <Form.Item
          label={this.translation('Upload')}
          name="upload"
          rules={[{ required: true, message: [this.translation('upload!')] }]}
        >
          <span>
            <ImgCrop width={width} height={height}>
              <Upload
                name="logo"
                disabled={disableUpload}
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                action={`${API_SITE.LogoUpload}?SiteId=${siteId}&SiteOfLogo=${userSite}`}
                headers={{
                  Authorization: Authorization
                }}
                beforeUpload={this.beforeUpload}
                onChange={this.handleChange}
              >
                {/* {imageUrl ? <img src={imageUrl} height="100px" alt="avatar" /> : uploadButton} */}
                {UploadedImage ? UploadedImage : uploadButton}
              </Upload>
            </ImgCrop>
            ({width}* {height})
          </span>
        </Form.Item>
      </Form>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  translationCache: getTranslationCache(),
  userProfile: getUserProfile()
});

export default connect(mapStateToProps)(LogoUploadFile);
